/**
 * @fileoverview Filter Operator Select Component
 * 
 * This component renders a dropdown for selecting filter operators
 * when multiple operators are available for a filter.
 * 
 * Requirements: 3.3, 3.4
 */

import React from 'react';

/**
 * Filter Operator Select Component
 * 
 * @param {Object} props - Component props
 * @param {FilterOperator[]} props.operators - Available operators
 * @param {FilterOperator} props.selectedOperator - Currently selected operator
 * @param {function(FilterOperator): void} props.onOperatorChange - Operator change handler
 * @param {boolean} props.disabled - Whether the select is disabled
 * @param {string} props.testId - Test ID
 */
export const FilterOperatorSelect = ({
  operators,
  selectedOperator,
  onOperatorChange,
  disabled = false,
  testId = 'filter-operator-select'
}) => {
  /**
   * Handle operator selection
   */
  const handleOperatorChange = (e) => {
    const operatorType = e.target.value;
    const operator = operators.find(op => op.type === operatorType);
    if (operator) {
      onOperatorChange(operator);
    }
  };

  if (!operators || operators.length <= 1) {
    return null;
  }

  return (
    <div className="filter-operator-select" data-testid={testId}>
      <select
        value={selectedOperator?.type || operators[0]?.type || ''}
        onChange={handleOperatorChange}
        disabled={disabled}
        className="operator-select"
        data-testid={`${testId}-dropdown`}
      >
        {operators.map((operator) => (
          <option key={operator.type} value={operator.type}>
            {operator.symbol ? `${operator.symbol} ${operator.label}` : operator.label}
          </option>
        ))}
      </select>
    </div>
  );
};
